<template>
  <div
    ref="container"
    :class="[
      $style.container,
      className,
      interactive && $style.containerInteractive,
    ]"
    @mousedown="startDrag"
    @mouseleave="stopDrag"
    @mouseup="stopDrag"
    @mousemove="onDrag"
    @touchstart.passive="startTouchDrag"
    @touchend="stopDrag"
    @touchmove.passive="onTouchDrag"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "DragScroll",

  props: {
    className: { type: String, default: "" },
    interactive: { type: Boolean, default: false },
  },

  data() {
    return {
      isDown: false,
      startX: 0,
      scrollLeft: 0,
    }
  },

  methods: {
    startDrag(e) {
      const el = this.$refs.container
      this.isDown = true
      this.startX = e.pageX - el.offsetLeft
      this.scrollLeft = el.scrollLeft
    },

    startTouchDrag(e) {
      const el = this.$refs.container
      const touch = e.touches[0]
      this.isDown = true
      this.startX = touch.pageX - el.offsetLeft
      this.scrollLeft = el.scrollLeft
    },

    stopDrag() {
      this.isDown = false
    },

    onDrag(e) {
      if (!this.isDown) return
      const el = this.$refs.container

      e.preventDefault()
      const x = e.pageX - el.offsetLeft
      const walk = (x - this.startX) * 1.5
      el.scrollLeft = this.scrollLeft - walk
    },

    onTouchDrag(e) {
      if (!this.isDown) return
      const el = this.$refs.container
      const touch = e.touches[0]
      const x = touch.pageX - el.offsetLeft
      const walk = (x - this.startX) * 1.5
      el.scrollLeft = this.scrollLeft - walk
    },
  },
}
</script>

<style lang="scss" module>
.container {
  overflow-x: auto;
  display: flex;
  gap: 0.75rem;
  cursor: grab;
  user-select: none;
  touch-action: pan-x;
  -webkit-overflow-scrolling: auto;
  img {
    transform: scale(-1, 1);
  }
}

.container:active {
  cursor: grabbing;
}

.container * {
  pointer-events: none; /* внутри нельзя кликать объектами — нужно для drag */
}

.containerInteractive * {
  pointer-events: auto;
}
</style>
